import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/esnext.string.replace-all.js";
import { addYears, compareDesc, format, isValid, parse, subYears } from 'date-fns';
export default defineComponent({
  name: 'DateTextField',
  props: {
    value: {
      type: String,
      default: ''
    },
    /**
     * В формате может отсутствовать день, если необходимо вводить только месяц
     * */
    format: {
      type: String,
      default: 'yyyy-MM-dd'
    },
    min: {
      type: Date,
      default: function _default() {
        return subYears(new Date(), 100);
      }
    },
    max: {
      type: Date,
      default: function _default() {
        return addYears(new Date(), 100);
      }
    },
    /**
     * Правила прогоняются для даты в исходном формате, переданном через prop format
     * */
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    label: {
      type: String,
      default: 'Дата'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['input'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
      expose = _ref.expose;
    var textField = ref(null);
    var lazyValue = ref('');
    var inputRules = computed(function () {
      var _props$rules;
      return [function (v) {
        return (v === null || v === void 0 ? void 0 : v.length) !== fullDateLength.value || validateDate(v !== null && v !== void 0 ? v : '') || 'Дата указана неверно';
      }, function (v) {
        return (v === null || v === void 0 ? void 0 : v.length) === 0 || (v === null || v === void 0 ? void 0 : v.length) === fullDateLength.value || 'Укажите дату в формате 10.10.1990';
      }, function (v) {
        return !props.required || validateDate(v !== null && v !== void 0 ? v : '') || 'Обязательное поле';
      }].concat(_toConsumableArray((_props$rules = props.rules) === null || _props$rules === void 0 ? void 0 : _props$rules.map(function (rule) {
        return function () {
          return rule(formattedDate.value);
        };
      })));
    });
    var onlyMonth = computed(function () {
      var _props$format;
      return !((_props$format = props.format) !== null && _props$format !== void 0 && _props$format.toLowerCase().includes('dd'));
    });
    var fullDateLength = computed(function () {
      return onlyMonth.value ? 7 : 10;
    });
    var lazyValueFormat = computed(function () {
      return onlyMonth.value ? 'MM.yyyy' : 'dd.MM.yyyy';
    });
    var placeholderText = computed(function () {
      var _lazyValue$value$leng, _lazyValue$value;
      var placeholder = onlyMonth.value ? 'мм.гггг' : 'дд.мм.гггг';
      return lazyValue.value + placeholder.slice((_lazyValue$value$leng = (_lazyValue$value = lazyValue.value) === null || _lazyValue$value === void 0 ? void 0 : _lazyValue$value.length) !== null && _lazyValue$value$leng !== void 0 ? _lazyValue$value$leng : 0);
    });
    var formattedDate = computed(function () {
      var _lazyValue$value2;
      if (((_lazyValue$value2 = lazyValue.value) === null || _lazyValue$value2 === void 0 ? void 0 : _lazyValue$value2.length) !== fullDateLength.value) {
        return '';
      }
      var date = parse(lazyValue.value, lazyValueFormat.value, new Date());
      if (!isValid(date)) {
        return '';
      }
      return format(date, props.format);
    });
    watch(function () {
      return [props.disabled, props.required];
    }, function () {
      var _textField$value;
      (_textField$value = textField.value) === null || _textField$value === void 0 ? void 0 : _textField$value.validate(true);
    });
    watch(function () {
      return props.value;
    }, function (val) {
      if (!val) {
        var _textField$value2;
        // NOTE: Когда удаляется символ из валидной даты выбрасывается input с пустым value,
        // условие нужно чтобы дата не стерлась полностью
        if (!((_textField$value2 = textField.value) !== null && _textField$value2 !== void 0 && _textField$value2.$data.isFocused)) {
          setDate({
            day: '',
            month: '',
            year: ''
          });
        }
        return;
      }
      var date = parse(val, props.format, new Date());
      if (!isValid(date)) {
        return;
      }
      setDate({
        day: !onlyMonth.value ? date.getDate().toString().padStart(2, '0') : '',
        month: (date.getMonth() + 1).toString().padStart(2, '0'),
        year: date.getFullYear().toString()
      });
    }, {
      immediate: true
    });
    function validateDate(value) {
      var date = parse(value, lazyValueFormat.value, new Date());
      return isValid(date) && compareDesc(props.min, date) === 1 && compareDesc(date, props.max) === 1;
    }
    function setDate(date) {
      var result = date.year ? '.' + date.year : '';
      if (date.month) {
        result = (onlyMonth.value ? '' : '.') + date.month + result;
      } else {
        result = '';
      }
      if (!onlyMonth.value) {
        result = date.day ? date.day + result : '';
      }
      lazyValue.value = result;
    }
    function emitInput() {
      if (formattedDate.value !== props.value) {
        emit('input', formattedDate.value);
      }
    }
    function handleInput(_x) {
      return _handleInput.apply(this, arguments);
    }
    function _handleInput() {
      _handleInput = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(val) {
        var _exec$, _exec, _exec$2, _exec2, _exec$3, _exec3;
        var dateParts;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(val === null)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              val = val.replaceAll(/[^0-9]/g, '');
              _context.next = 5;
              return nextTick();
            case 5:
              dateParts = onlyMonth.value ? {
                day: '',
                month: val.slice(0, 2),
                year: val.slice(2, 6)
              } : {
                day: val.slice(0, 2),
                month: val.slice(2, 4),
                year: val.slice(4, 8)
              };
              dateParts.day = (_exec$ = (_exec = /^0[1-9]?|^[12][0-9]?|^3[01]?/.exec(dateParts.day)) === null || _exec === void 0 ? void 0 : _exec[0]) !== null && _exec$ !== void 0 ? _exec$ : '';
              dateParts.month = dateParts.day.length === 2 || onlyMonth.value ? (_exec$2 = (_exec2 = /^0[1-9]?|^1[012]?/.exec(dateParts.month)) === null || _exec2 === void 0 ? void 0 : _exec2[0]) !== null && _exec$2 !== void 0 ? _exec$2 : '' : '';
              dateParts.year = dateParts.month.length === 2 ? (_exec$3 = (_exec3 = /(^(19|2\d)\d{0,2})|^[12]/.exec(dateParts.year)) === null || _exec3 === void 0 ? void 0 : _exec3[0]) !== null && _exec$3 !== void 0 ? _exec$3 : '' : '';
              setDate(dateParts);
              emitInput();
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _handleInput.apply(this, arguments);
    }
    expose({
      reset: function reset() {
        lazyValue.value = '';
        emitInput();
      },
      validate: function validate() {
        var _textField$value3;
        (_textField$value3 = textField.value) === null || _textField$value3 === void 0 ? void 0 : _textField$value3.validate(true);
      },
      valid: computed(function () {
        var _textField$value4;
        return (_textField$value4 = textField.value) === null || _textField$value4 === void 0 ? void 0 : _textField$value4.valid;
      })
    });
    return {
      textField: textField,
      lazyValue: lazyValue,
      placeholderText: placeholderText,
      inputRules: inputRules,
      handleInput: handleInput
    };
  }
});